// @flow strict

import type {USER_BASE_INFO} from 'src/types/crm';

import {useSelector} from 'react-redux';
import {useTRMEnabled, useCrmRedesignedEnabled} from 'src/hooks/product-flags';
import {selectUserInfo} from 'src/selectors/crm';


export function useTrmUserInfo(): USER_BASE_INFO | null {
  const trmEnabled = useTRMEnabled();
  const userInfo = useSelector(selectUserInfo);

  return trmEnabled ? userInfo : null;
}

export const useCRMMigrationEnabled = (): boolean => {
  const crmRedesignedEnabled = useCrmRedesignedEnabled();
  return crmRedesignedEnabled;
};
